import React from "react";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";

const serviceData = {
  ecommerce: {
    title: "Reliable Supplies Delivered Just In Time.",
    description:
      "JIT ensures that essential products, daily household items, and important materials reach you exactly when required, without any delays. Our platform is designed to make ordering effortless, offering seamless browsing, secure checkout, and reliable doorstep delivery. With real-time updates, you always stay informed about your order status from start to finish. Whether you need quick restocks, urgent replacements, or scheduled deliveries, JIT handles it with speed and accuracy. We aim to eliminate the stress of last-minute shortages by providing a dependable supply system—built around your time and convenience. With JIT, every delivery is timely, transparent, and truly Just In Time.",
    image: require("./../../images/services/1.png"),
  },

  labour: {
    title: "Skilled Labour, Ready When You Are.",
    description:
      "JIT helps you find trained, verified, and reliable labour professionals for a wide range of tasks—whether for home assistance, repairs, maintenance, or business operations. Our service ensures quick availability, transparent pricing, and trustworthy workers who meet quality standards. Each labour request is handled with priority to match you with the right professional based on skill and urgency. We focus on making the hiring experience smooth by removing waiting times, confusion, and unnecessary processes. From small household needs to large tasks requiring coordinated effort, JIT guarantees dependable manpower whenever you need it. With us, skilled support is always just a request away.",
    image: require("./../../images/services/2.png"),
  },

  apartments: {
    title: "Reliable Apartment Maintenance & Services",
    description:
      "JIT provides dependable apartment services designed to keep residential spaces safe, functional, and well maintained. Our offerings include professional plumbing, electrical work, and general maintenance, delivered by skilled technicians with a focus on quality and efficiency. We ensure timely service, clear communication, and minimal disruption, helping residents and property owners address issues quickly and effectively. Whether it’s routine maintenance or urgent repairs, JIT delivers reliable solutions tailored to apartment needs. With our customer-focused approach, you can count on consistent service, professional execution, and peace of mind for your living spaces.",
    image: require("./../../images/services/3.png"),
  },
};

function AboutCompany() {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get("id");

  const content = serviceData[id] || serviceData["ecommerce"]; // default

  return (
    <div className="section-full p-t80 bg-white">
      <div className="container">
        <div className="section-content">
          <div className="m-service-containt text-black">
            <div className="row">
              <div className="col-md-5 col-sm-12">
                <div className="service-about-left">
                  <div className="mt-media">
                    <img src={content.image} alt={content.title} />
                  </div>
                </div>
              </div>

              <div className="col-md-7 col-sm-12">
                <div className="service-about-right m-b30">
                  <h3 className="m-t0">{content.title}</h3>
                  <p>{content.description}</p>
                  <div>
                    <NavLink
                      to={"#"}
                      className="site-button-secondry btn-effect"
                    >
                      Contact Us
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutCompany;
